import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { DraggableLabel } from "./draggable-label";
import { readOnlyValue } from "../../../attributes/lib/attribute-data";
import { attributeUUID } from "shared/attribute-uuid";
import { useSortable } from "@dnd-kit/sortable";

const shouldHideDeprecatedCountry = (key, collection) =>
    key === attributeUUID.deprecatedCountry && attributeUUID.country in collection && collection[attributeUUID.deprecatedCountry] == null;

export const SortableGroupItem = ({ id, index, attributeList, readOnly, disabled, collection, onEditGroup, onRemove }) => {
    const { listeners, setNodeRef, setActivatorNodeRef, transform, transition } = useSortable({ id });
    const style = {
        transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
        transition,
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
        >
            <div
                key={id}
                id={id}
                className="attribute-group-item selected-item draggable-item"
                onClick={() => onEditGroup(collection, id)}
            >
                {!readOnly && !disabled && (
                    <div
                        ref={setActivatorNodeRef}
                        className="flex"
                        {...listeners}
                        style={{ cursor: "grab" }}
                    >
                        <FontAwesomeIcon icon={faEllipsisVertical} />
                        <FontAwesomeIcon icon={faEllipsisVertical} />
                    </div>
                )}

                {Object.keys(collection)
                    .filter((key) => key !== "id")
                    .filter((key) => !shouldHideDeprecatedCountry(key, collection))
                    .map((key) => {
                        const attrData = attributeList.find(({ uuid }) => uuid === key);

                        // This prevents products with the old country attribute from crashing
                        const countryOverride =
                            !attrData && key === attributeUUID.deprecatedCountry ? attributeList.find(({ name }) => name === "Country") : attrData;

                        return (
                            <DraggableLabel
                                key={`output_${key}`}
                                title={countryOverride?.name}
                                value={readOnlyValue(collection[key], countryOverride?.componentType)}
                            />
                        );
                    })}

                {!readOnly && !disabled && (
                    <button
                        className="close"
                        onClick={(e) => onRemove(e, index)}
                    >
                        <FontAwesomeIcon icon={faTimesCircle} />
                    </button>
                )}
            </div>
        </div>
    );
};
